import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LocalStorage from 'utils/bom-dom-manipulation/local-storage';
import { ModalWidth, ZINDEX_HIGH_2 } from 'utils/constants/app/ui';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { isMobile } from 'utils/is-mobile';
import { Modal, ModalButtons } from 'components/Modal';
import { updateQuery } from 'components/QueryRoute';
import { Button } from 'newcomponents/UI/Button';
import { useSwitchSession } from 'hooks/auth/useSwitchSession';
import { getUser } from 'store/selectors/user-data';
import './index.less';

export const WalletModal = ({
  activeMenu,
  haveCancel
}: {
  activeMenu: string;
  haveCancel: boolean;
}) => {
  const { switchSession } = useSwitchSession();
  const { t } = useTranslation();
  const history = useHistory();
  const [isSwitchWalletModalVisible, setIsSwitchWalletModalVisible] =
    useState(false);

  const user = useSelector(getUser);
  useEffect(() => {
    if (user.owner_id && activeMenu === 'accounts:settings') {
      setIsSwitchWalletModalVisible(true);
    } else {
      setIsSwitchWalletModalVisible(false);
    }
  }, [activeMenu, user.owner_id]);

  return isSwitchWalletModalVisible ? (
    <Modal
      zIndex={ZINDEX_HIGH_2}
      image={{
        lib: 'generic',
        name: 'Info',
        theme: 'colored'
      }}
      centered
      closable={false}
      maxWidth={isMobile() ? ModalWidth.MOBILE_350 : ModalWidth.DESKTOP_420}
      renderInBody={isMobile()}
      getContainer={'accountModal__wrapper__Layout'}
      title={t('account.switchWalletTitle')}
      visible={isSwitchWalletModalVisible}
      className="switchWalletModal"
    >
      <ModalButtons direction="column" className="modalButtons">
        <p className="switchWallet__infoText">
          {t('account.switchWalletText')}
        </p>
        <div className="buttonWrapper">
          {haveCancel && (
            <Button
              type="cancel"
              size="large"
              onClick={() => {
                history.push(updateQuery({ accounts: '*', profile: '*' }));
              }}
            >
              {t('account.cancel')}
            </Button>
          )}
          <Button
            size="large"
            type="primary"
            onClick={() => {
              const parentAccountCurrency = LocalStorage.getItem(
                storageKeyName('account', 'PARENT_ACCOUNT_CURRENCY')
              );

              switchSession(parentAccountCurrency);
              setIsSwitchWalletModalVisible(false);
            }}
          >
            {t('account.switch')}
          </Button>
        </div>
      </ModalButtons>
    </Modal>
  ) : null;
};
